import './HeroLogo.css'

const HeroLogo = () => {
  return (
    <div className="hero__logo">
      <img 
        src="/assets/logo-128x128.svg" 
        alt="Unity-BOT Logo" 
        className="hero__logo-img"
      />
      <h2 className="hero__logo-title">Unity-BOT</h2>
    </div>
  )
}

export default HeroLogo
